import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const ErrorMessage = styled.small`
  color: ${({ theme }) => theme.colors.variant.danger};
`;
